export default function LoanActionButtons({
    isEncompassWeb,
    isReadOnly,
    onSave,
    onGenerate
}) {
    return (
        <>
            {!isEncompassWeb && (
                <button
                    onClick={onSave}
                    className={`btn-base btn-save ${isReadOnly ? 'cursor-not-allowed opacity-60' : ''}`}
                    disabled={isReadOnly}
                >
                    Save
                </button>
            )}

            {isEncompassWeb && (
                <button
                    id="print"
                    onClick={onGenerate}
                    className="btn-base btn-save"
                >
                    Generate Loan App
                </button>
            )}
        </>
    );
}